module.exports = __webpack_public_path__ + "static/logo-34e34673b3f0fb5b1c1874d9091d270b.png";